import React from 'react';

interface FilterProps {
    width?: number;
    height?: number;
}

export const Filter = ({ width = 16, height = 16 }: FilterProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
    >
        <path
            d="M14 1.16663V2.33329H0V1.16663H14ZM4.66667 12.8333H9.33333V11.6666H4.66667V12.8333ZM2.33333 7.58329H11.6667V6.41663H2.33333V7.58329Z"
            fill="currentColor"
        />
    </svg>
);
